import { computed } from 'vue';
function useButton(_ref) {
  let {
    component,
    type,
    href,
    to
  } = _ref;
  const buttonTag = computed(() => {
    if (href) return 'a';else if (to) return 'router-link';
    return component.value;
  });
  const buttonType = computed(() => {
    let buttonType = type;
    if (!type && buttonTag.value === 'button') buttonType = 'button';
    return buttonType;
  });
  return {
    buttonTag,
    buttonType
  };
}
export { useButton };